<app-header (toggleSideBarForMe)='sideBarToggler($event)'></app-header>
<mat-drawer-container>
    <mat-drawer mode="over" #sidenav [opened]="sideBarOpen">
        <app-sidebar (toggleSideBarForMe)='sideBarToggler($event)' ></app-sidebar>
    </mat-drawer>
    <mat-drawer-content>
        <router-outlet class="apearAnimation"></router-outlet>
    </mat-drawer-content>
</mat-drawer-container>

<app-footer></app-footer>